import React from "react";
import { Form, Input } from "antd";

const RegisterIRD = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="ird"
      label="IRD Number"
      rules={[
        {
          min: 8,
          message: "Min length must be at least 8 numbers",
        },
        {
          max: 9,
          message: "Max length 9 numbers",
        },
        {
          pattern: /^[0-9]+$/,
          message: "Accept number only",
        },
      ]}
    >
      <Input
        showCount
        maxLength={9}
        // minLength={8}
        // max={9}
        // type="number"
        placeholder="IRD Number"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default RegisterIRD;
